import React, { useState } from "react";
import Rating from "react-rating";
import { Input, Label } from "reactstrap";

// Assets
import { StarIcon, StarIconFilled } from "../assets/img/icons";

// Components
import PlaybookCard from "./PlaybookCard";

const ExpertProjectReviewFeedBackForm = props => {
  const [communicationFromClient, setCommunicationFromClient] = useState(0);
  const [compensation, setCompensation] = useState(0);
  const [overAllExperience, setOverAllExperience] = useState(0);
  const [reviewNotes, setReviewNotes] = useState("");
  const [checkboxCommentPublic, setCheckboxCommentPublic] = useState(false);

  const handleCommunicationFromClient = value =>
    setCommunicationFromClient(value);
  const handleCompensation = value => setCompensation(value);
  const handleOverAllExperience = value => setOverAllExperience(value);

  const handleProjectReview = e => setReviewNotes(e.target.value);

  const handleCheckboxCommentPublic = () =>
    setCheckboxCommentPublic(!checkboxCommentPublic);

  const {
    projectDetails: { id, projectDetails },
    saveProjectFeedback
  } = props;

  return (
    <div className="feedback-component d-flex justify-content-start">
      <PlaybookCard
        data={projectDetails}
        isPreview={"true"}
        boxShadow={false}
        placeHolder={true}
        bannerImageUrl={projectDetails.bannerImageUrl}
        tag={"div"}
      />
      <div className="rating-component">
        <div className="form-wrapper">
          <div className="rating-wrapper d-flex align-items-center">
            <Rating
              initialRating={communicationFromClient}
              emptySymbol={<StarIcon />}
              fullSymbol={<StarIconFilled />}
              onChange={handleCommunicationFromClient}
            />{" "}
            <h5 className="font-weight-bold ml-3">Communication from client</h5>
          </div>
          <div className="rating-wrapper d-flex align-items-center">
            <Rating
              initialRating={compensation}
              emptySymbol={<StarIcon />}
              fullSymbol={<StarIconFilled />}
              onChange={handleCompensation}
            />{" "}
            <h5 className="font-weight-bold ml-3">Compensation</h5>
          </div>
          <div className="rating-wrapper d-flex align-items-center">
            <Rating
              initialRating={overAllExperience}
              emptySymbol={<StarIcon />}
              fullSymbol={<StarIconFilled />}
              onChange={handleOverAllExperience}
            />{" "}
            <h5 className="font-weight-bold ml-3">Overall Experience</h5>
          </div>
          <div className="field-wrapper">
            <label>Tell us about your experience with this Playbook</label>
            <Input
              type="textarea"
              placeholder="Leave feedback and let others know how things went"
              style={{
                background: "#F3F3F4",
                border: "none",
                borderRadius: "5px",
                fontSize: "14px",
                minHeight: 132
              }}
              onChange={handleProjectReview}
            />
          </div>
          <div className="btn-wrapper d-flex align-items-center justify-content-stretch">
            <div className="checkbox-wrapper">
              <Label htmlFor={`agreeCheck-${id}`}>
                <Input
                  id={`agreeCheck-${id}`}
                  name={"agreeCheck"}
                  type="checkbox"
                  defaultChecked={checkboxCommentPublic}
                  value={"value"}
                  onChange={handleCheckboxCommentPublic}
                />
                <span
                  className={`checkbox-placeholder ${checkboxCommentPublic &&
                    "active"}`}
                />
                <span>I don’t want my comments made public.</span>
              </Label>
            </div>
            <button
              className="btn btn-primary mr-0 ml-auto"
              onClick={() =>
                saveProjectFeedback({
                  id,
                  communicationFromClient,
                  compensation,
                  overAllExperience,
                  reviewNotes,
                  checkboxCommentPublic
                })
              }
            >
              Submit My Feedback
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpertProjectReviewFeedBackForm;
